<template>
    <v-container>
        <v-row>
            <v-col>
                <h2 style="padding-left:10px;">Change Details</h2>
            </v-col>
        </v-row>
        <v-col>
            <v-tabs v-model="formTabs" color="var(--houseColor)" fixed-tabs>
                <v-tab>
                    <v-icon>mdi-account</v-icon>
                </v-tab>
                <v-tabs-slider></v-tabs-slider>
                <v-tab>
                    <v-icon>mdi-phone</v-icon>
                </v-tab>
                <v-tabs-slider></v-tabs-slider>
                <v-tab>
                    <v-icon>mdi-map-marker</v-icon>
                </v-tab>
            </v-tabs>
        </v-col>
        <v-col v-if="spinner" align="center">
            <v-progress-circular :color="($vuetify.theme.dark) ? 'var(--darkColor)' : 'var(--lightColor)'" size="72"
                indeterminate></v-progress-circular>
        </v-col>
        <v-form v-if="!spinner" ref="form" lazy-validation>
            <v-card v-if="formTabs == 0">
                <v-card-subtitle class="text-h6">Personal Infomation</v-card-subtitle>
                <v-card-text>
                    <v-text-field disabled v-model="formData.formFirstName.data" label="First Name:"></v-text-field>
                    <v-text-field disabled v-model="formData.formLastName.data" label="Second Name:"></v-text-field>
                    <v-text-field filled dense v-model="formData.formAliasName.data" label="Alias:"></v-text-field>
                    <v-text-field disabled name="dob" v-model="formData.formDob.data" label="Date of birth:">
                    </v-text-field>
                    <v-select disabled label="Nationality:" :items="nationalities" item-text="Nationality"
                        v-model='formData.formNationality.data'>

                    </v-select>
                    <v-text-field disabled v-model="formData.formCreated.data" label="Created:"></v-text-field>

                </v-card-text>
            </v-card>

            <v-card v-if="formTabs == 1">
                <v-card-subtitle class="text-h6">Contact Information</v-card-subtitle>
                <v-card-text>
                    <v-text-field disabled v-model="formData.formEmail.data" label="Email:"></v-text-field>
                    <v-text-field filled dense v-model="formData.formPhone.data" label="Phone number:"
                        :rules="this.phoneNumberRules">
                    </v-text-field>
                </v-card-text>
            </v-card>

            <v-card v-if="formTabs == 2">
                <v-card-subtitle class="text-h6">Address Information</v-card-subtitle>
                <v-card-text>
                    <v-text-field filled dense v-model="formData.formAddress1.data" label="Address 1:"></v-text-field>
                    <v-text-field filled dense v-model="formData.formAddress2.data" label="Address 2:"></v-text-field>
                    <v-text-field filled dense v-model="formData.formPostcode.data" label="PostCode:" :rules="this.postcodeRules">
                    </v-text-field>
                    <!-- <v-text-field v-if="postcodeRegex != null" filled dense v-model="formData.formPostcode.data"
                        label="PostCode:" :rules="[v => postcodeRegex+'+$/'.test(v) || 'Postcode must be valid in ' + 'the selected country'] || 'Postcode must be valid (Uppercase)']">
                    </v-text-field> -->
                    <v-text-field filled dense v-model="formData.formTownCity.data" label="Town/City:"></v-text-field>
                    <v-text-field filled dense v-model="formData.formRegion.data" label="Region:"></v-text-field>
                    <v-select filled dense label="Country:" v-model="formData.formCountry.data"
                        :items="COUNTRY_ADDRESS_POSTALS" item-text="name" @input="postcodeRegexChange">
                    </v-select>

                </v-card-text>
            </v-card>

            <v-card class="mt-3">
                <v-card-actions>
                    <v-btn color="red" v-on:click="ResetForm()" class="float-left">Reset</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn v-on:click="validateForm" class="navColor float-right">Save Changes</v-btn>
                </v-card-actions>
            </v-card>
        </v-form>
    </v-container>
</template>

<script>
import moment from 'moment';
import accessHelper from '@/mixins/accessHelper.js';
import RestResource from '../RestResource.js';
const restResourceService = new RestResource();

import { mapActions, mapGetters } from 'vuex';
import postcodeHelper from '@/mixins/postcodeHelper.js';
export default {
    name: "ChangePersonalDetailsPage",
    props: {

    },
    components: {

    },
    mixins: [accessHelper, postcodeHelper],
    data: () => ({
        formTabs: 0,
        postcodeRegex: null,

        phoneNumberRules: [],
        postcodeRules: [],


        formData: {
            formDob: {
                data: null,
                SuccessMessages: "",
                ErrorMessages: ""
            },
            formFirstName: {
                data: null,
                SuccessMessages: "",
                ErrorMessages: ""
            },
            formLastName: {
                data: null,
                SuccessMessages: "",
                ErrorMessages: ""
            },
            formNationality: {
                data: null,
                SuccessMessages: "",
                ErrorMessages: ""
            },
            formPhone: {
                data: null,
                SuccessMessages: "",
                ErrorMessages: ""
            },
            formEmail: {
                data: null,
                SuccessMessages: "",
                ErrorMessages: ""
            },
            formAliasName: {
                data: null,
                SuccessMessages: "",
                ErrorMessages: ""
            },
            formCreated: {
                data: null,
                SuccessMessages: "",
                ErrorMessages: ""
            },
            formAddress1: {
                data: null,
                SuccessMessages: "",
                ErrorMessages: ""
            },
            formAddress2: {
                data: null,
                SuccessMessages: "",
                ErrorMessages: ""
            },
            formCountry: {
                data: null,
                SuccessMessages: "",
                ErrorMessages: ""
            },
            formPostcode: {
                data: null,
                SuccessMessages: "",
                ErrorMessages: ""
            },
            formRegion: {
                data: null,
                SuccessMessages: "",
                ErrorMessages: ""
            },
            formTownCity: {
                data: null,
                SuccessMessages: "",
                ErrorMessages: ""
            },
        },

        spinner: false,
    }),
    mounted: function () {
        if (this.getAccountDetails.id == null)
            this.fetchAccountDetails();

        this.postcodeRegexChange();
    },
    watch: {
        getAccount: {
            //Handler just watches for deep mutations
            //Stops anything being called untill account api call finishes
            handler(account) {
                if (account != null) {
                    this.formData.formDob.data = moment(this.getAccount.dob).format("DD/MM/YYYY");
                    this.formData.formFirstName.data = this.getAccount.firstname;
                    this.formData.formLastName.data = this.getAccount.lastname;
                    this.formData.formNationality.data = this.getAccount.nationality.charAt(0).toUpperCase() + this.getAccount.nationality.slice(1);
                    this.formData.formPhone.data = this.getAccount.phone;
                    this.formData.formEmail.data = this.getAccount.email;
                    this.formData.formAliasName.data = this.getAccount.aliasName;
                    this.formData.formCreated.data = moment(this.getAccount.createdDate).fromNow();
                }
            },
            immediate: true,
            deep: true
        },
        getAccountDetails: {
            //Handler just watches for deep mutations
            //Stops anything being called untill account api call finishes
            handler(accountDetails) {
                if (accountDetails != null) {
                    this.formData.formAddress1.data = this.getAccountDetails.address1;
                    this.formData.formAddress2.data = this.getAccountDetails.address2;
                    this.formData.formCountry.data = this.getAccountDetails.country;
                    this.formData.formPostcode.data = this.getAccountDetails.postcode;
                    this.formData.formRegion.data = this.getAccountDetails.region;
                    this.formData.formTownCity.data = this.getAccountDetails.townCity;
                }
            },
            immediate: true,
            deep: true
        },
        'formData.formPhone.data'() {
            this.phoneNumberRules = [];
        },
        'formData.formPostcode.data'() {
            this.postcodeRules = [];
        }
    },
    computed:
        mapGetters([
            'getAccount',
            'getAccountDetails',
        ]),
    methods: {
        ...mapActions([
            'fetchAccount',
            'fetchAccountBalance',
            'fetchAccountDetails',
        ]),
        postcodeRegexChange() {
            this.COUNTRY_ADDRESS_POSTALS.forEach(el => {
                if (el.name == this.formData.formCountry.data) {
                    return this.postcodeRegex = el.postal;
                }
            })
        },
        ResetForm() {
            //Best for now, as reset sets to null abandoning defaults.
            //Also setting defaults values using :value="" is overriden by v-model, which are null on reset.
            this.$router.go(0);
        },
        async validateForm() {
            //Add Rules to form - eslint, allows escape characters on the next line.
            // eslint-disable-next-line
            this.phoneNumberRules = [v => /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/.test(v) || 'Postcode must be valid in ' + 'the selected country'];
            // eslint-disable-next-line
            this.postcodeRules = this.postcodeRegex;


            if (this.formData.formAddress1.data.includes(',') || this.formData.formAddress2.data.includes(',') || this.formData.formRegion.data.includes(',') || this.formData.formTownCity.data.includes(',')) {
                return this.$emit('snack', "No commas allowed in address");
            }
            //Wait for rules to complete then check if they have been broken. 
            let self = this;
            setTimeout(function () {
                if (self.$refs.form.validate())
                    self.submitForm();
                else
                    return self.$emit('snack', 'Invalid Inputs');
            })
        },
        async submitForm() {

            if (this.getAccount == null)
                return this.$emit('snack', "Account not available");
            if (this.getAccountDetails.id == -1)
                return this.$emit('snack', "Account not available");

            this.spinner = true;
            const newAccount = {
                id: this.getAccount.id,
                accountKey: this.getAccount.accountKey,
                aliasName: this.formData.formAliasName.data,
                createdDate: moment(this.getAccount.createdDate).valueOf(),
                email: this.formData.formEmail.data,
                firstname: this.formData.formFirstName.data,
                lastname: this.formData.formLastName.data,
                password: this.getAccount.password,
                paymentId: this.getAccount.paymentId,
                phone: this.formData.formPhone.data,
                roles: this.getAccount.roles,
                sites: this.getAccount.sites,
                status: this.getAccount.status,
                type: this.getAccount.type,
                verificationDate: this.getAccount.verificationDate,
                verified: this.getAccount.verified,
                dob: this.getAccount.dob,
                nationality: this.formData.formNationality.data,
            }

            const newAccountDetails = {
                id: this.getAccountDetails.id,
                accountId: this.getAccountDetails.accountId,
                address1: this.formData.formAddress1.data,
                address2: this.formData.formAddress2.data,
                country: this.formData.formCountry.data,
                latitude: this.getAccountDetails.latitude,
                longitude: this.getAccountDetails.longitude,
                postcode: this.formData.formPostcode.data,
                region: this.formData.formRegion.data,
                townCity: this.formData.formTownCity.data,
            }
            const res1 = await restResourceService.updateAccount(newAccount);
            const res2 = await restResourceService.updateAccountDetails(newAccountDetails);

            if (res1 == 200 && res2 == 200)
                this.$emit('snack', "Successfully Updated Details")
            this.spinner = false;
            this.fetchAccount();
            this.fetchAccountDetails();
            this.$router.push({ path: '/myAccount' });
        }
    },
}
</script>

<style scoped>
</style>